/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum PaymentMethod {
  Cash = 'CASH',
  Card = 'CARD'
}
